import { Injectable } from '@angular/core';
import { MessengerTranslationGroup } from '../../models/matrix-messenger/messenger.model';
import { AuditEvent } from './notifications.model';
import { NotificationsService } from './notifications.service';
import { MessengerMessageOptions } from '@core/models/matrix-messenger/messenger-message-options.model';

@Injectable({
  providedIn: 'root',
})
export class MessengerNotificationsAdapter {
  constructor(private notificationsService: NotificationsService) {}

  adaptHashedNotifications(entries): AuditEvent[] {
    const hashes = Object.keys(entries.notifications).filter(
      (key) => key !== 'lastRoomEvents',
    );

    return hashes.map((hash) => {
      const newestNotification = entries.notifications[hash].reduce((a, b) =>
        new Date(b.time) > new Date(a.time) ? b : a,
      );
      const findRoom = entries.lastRoomEvents.find(
        (room) => newestNotification.room.id === room.roomId,
      );

      const messageOptions: MessengerMessageOptions = {
        type: newestNotification.type,
        roomDisplayName: newestNotification.room.displayName,
        personDisplayName: newestNotification.person.displayName,
        isDirect: newestNotification.room.directChat,
        count: entries.notifications[hash].length,
        roomId: newestNotification.room.id,
        hash: hash,
      };

      return {
        id: this.generateId(messageOptions),
        type: 'Notification',
        _resourceType: 'AuditEvent',
        icon: '',
        read: false,
        time: newestNotification.time,
        text: this.generateMessage(messageOptions),
        path: newestNotification.path,
        room: {
          roomId: findRoom.roomId,
          eventId: findRoom.eventId,
        },
      };
    });
  }

  getNotificationByParams(params): MessengerTranslationGroup {
    const { type, count, isDirect } = params;
    const messages = this.notificationsService.getMessengerNotifications();

    return messages.find((message) => {
      return (
        message.type === type &&
        message.directChat === isDirect &&
        message.isMultiple === count > 1
      );
    });
  }

  generateId(params): string {
    const { roomId, type, hash } = params;
    const findMessage = this.getNotificationByParams(params);
    return findMessage.groupedByHash ? `${hash}-${type}` : `${roomId}-${type}`;
  }

  generateMessage(params): string {
    const { count, roomDisplayName, personDisplayName } = params;
    const findMessage = this.getNotificationByParams(params);

    const displayParams = {
      count,
      personDisplayName,
      roomDisplayName,
    };

    return findMessage && findMessage.text(displayParams);
  }
}
